module.exports = "<h2><mat-icon style=\"vertical-align: middle\">warning</mat-icon>&nbsp; {{loc.get('DialogNoResellerTitle')}}</h2>\n<p [innerHTML]=\"loc.get('DialogNoResellerBody')\"></p>\n<a *ngIf=\"isIT\" href=\"tel:800979383\"><img src=\"assets/num_verde_rsc55.jpg\"></a>\n<div style=\"margin-top: 10px; text-align: right\">\n  <button mat-raised-button (click)=\"closeDialog()\">{{loc.get('Chiudi')}}</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialogs/no-resellers-found-dialog/no-resellers-found-dialog.html
// module id = ./src/app/dialogs/no-resellers-found-dialog/no-resellers-found-dialog.html
// module chunks = main